/** The product's mark: a line rising over a quiet baseline, in ink on a rounded square. */
export function BrandMark() {
  return (
    <span className="brand__mark" aria-hidden="true">
      <svg viewBox="0 0 20 20" fill="none">
        <path d="M3.5 16h13" stroke="currentColor" strokeOpacity="0.35" strokeWidth="1.6" strokeLinecap="round" />
        <path d="M3.5 12.2 7.6 8.6l3 2.4 5-5.2" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="15.6" cy="5.8" r="1.7" fill="currentColor" />
      </svg>
    </span>
  );
}
